module.exports = __webpack_public_path__ + "assets/img/00124.d5ba341a.png";